<template>
	<section id="home" class="s-home target-section" data-parallax="scroll" data-image-src="/static/images/header-bg.jpg" data-natural-width=3600 data-natural-height=2400 data-position-y=center>
		<div class="overlay"></div>
		<div class="shadow-overlay"></div>
		<canvas id="home-dust" class="dust"></canvas>

		<div class="home-content">
			<div class="row home-content__main">
				<h3 class="tt" v-html="$t('titles.homeWelcome')"></h3>
				<h1 class="tt" v-html="$t('texts.homeGreetings')"></h1>

				<div class="home-content__buttons">
					<a href="#about" class="smoothscroll btn btn--stroke tt">{{ $t('buttons.homeAbout') }}</a>
					<a href="#installation-addons" class="smoothscroll btn btn--stroke tt">{{ $t('buttons.homeHowToPlay') }}</a>
				</div>
			</div>

			<div class="home-content__scroll">
				<a href="#about" class="scroll-link smoothscroll">
					<span class="tt">{{ $t('titles.homeMore') }}</span>
				</a>
			</div>

			<div class="home-content__line"></div>
		</div>

		<SocialButtonsTitles/>
	</section>
</template>

<script>
	import SocialButtonsTitles from '../socialButtons/ButtonsTitles';
	export default {
		name: 'SectionHome',
		components: {SocialButtonsTitles}
	}

	// Dust Particles Simulation by bionicoz based on
	// Basic Particle Animation
	// Author: Brandon John-Freso
	$(function () {
		// width and height
		const width = window.innerWidth ;
		const height = window.innerHeight ;

		// number of particles
		const particleCount = 700;

		// this is an array which will hold our particles Object/Class
		let particles = [];

		// set canvas size
		const canvas = $('#home-dust').get(0);
		canvas.width = width;
		canvas.height = height;

		// ctx stands for context and is the "cursor" of our canvas element.
		const ctx = canvas.getContext('2d'); // settng the context to 2d rather than the 3d WEBGL
		ctx.globalCompositeOperation = 'lighter';
		let mouse = {
			x: 0,
			y: 0,
			rx: 0,
			ry: 0,
			speed: 45,
			delta: 0
		};

		/**
		 * Set mouse listener.
		 */
		document.addEventListener('mousemove', function (e) {
			mouse.x = e.clientX || e.pageX;
			mouse.y = e.clientY || e.pageY;
			mouse.x -= width / 2;
			mouse.y -= height / 2;
		}, false);



		/**
		 * Generate random norm.
		 * @param {Number} mean
		 * @param {Number} stdev
		 * @returns {Number} random norm
		 */
		function randomNorm(mean, stdev) {
			return Math.abs(Math.round((Math.random() * 2 - 1) + (Math.random() * 2 - 1) + (Math.random() * 2 - 1)) * stdev) + mean;
		}



		/**
		 * Setup particles class.
		 * @constructor
		 */
		function Particle() {
			// using hsl is easier when we need particles with similar colors
			this.h = 45;
			this.s = Number(40 * Math.random()) + 30;
			this.l = Number(40 * Math.random()) + 30;
			this.a = 0.5 * Math.random();

			this.color = "hsla(" + this.h + "," + this.s + "%," + this.l + "%," +(this.a)+ ")";
			this.shadowcolor = "hsla(" + this.h + "," + this.s + "%," + this.l + "%," + parseFloat(this.a - 0.55) + ")";

			this.x = Math.random() * width;
			this.y = Math.random() * height;
			this.direction = {
				x: -1 + Math.random() * 2,
				y: -1 + Math.random() * 2
			};

			//this.radius = 9 * ((Math.random()*2-1)+(Math.random()*2-1)+(Math.random()*2-1)+3);
			this.radius = randomNorm(0,4);
			this.scale = 0.8 * Math.random() + 0.5;
			this.rotation = Math.PI / 4 * Math.random();

			this.grad = ctx.createRadialGradient(this.x, this.y, this.radius, this.x, this.y, 0);
			this.grad.addColorStop(0, this.color);
			this.grad.addColorStop(1, this.shadowcolor);

			this.vx = (2 * Math.random() + 4) * .01 * this.radius;
			this.vy = (2 * Math.random() + 4) * .01 * this.radius;

			this.valpha = 0.01 * Math.random() - 0.02;



			/**
			 * Move particle.
			 */
			this.move = function () {
				this.x += this.vx * this.direction.x;
				this.y += this.vy * this.direction.y;
				this.rotation += this.valpha;
				//this.radius*= Math.abs((this.valpha*0.01+1));
			};



			/**
			 * Change direction.
			 * @param {String} axis axis
			 */
			this.changeDirection = function (axis) {
				this.direction[axis] *= -1;
				this.valpha *= -1;
			};



			/**
			 * Draw particle.
			 */
			this.draw = function () {
				ctx.save();
				ctx.translate(this.x + mouse.rx / -20 * this.radius, this.y + mouse.ry / -20 * this.radius);
				ctx.rotate(this.rotation);
				ctx.scale(1, this.scale);

				this.grad = ctx.createRadialGradient(0, 0, this.radius, 0, 0, 0);
				this.grad.addColorStop(1, this.color);
				this.grad.addColorStop(0, this.shadowcolor);
				ctx.beginPath();
				ctx.fillStyle = this.grad;
				ctx.arc(0, 0, this.radius, 0, Math.PI * 2, false);
				ctx.fill();
				ctx.restore();
			};



			/**
			 * Check boundary.
			 */
			this.boundaryCheck = function () {
				if (this.x >= width * 1.2) {
					this.x = width * 1.2;
					this.changeDirection('x');
				} else if (this.x <= -width * 0.2) {
					this.x = -width * 0.2;
					this.changeDirection('x');
				}

				if (this.y >= height * 1.2) {
					this.y = height * 1.2;
					this.changeDirection('y');
				} else if (this.y <= -height * 0.2) {
					this.y = -height * 0.2;
					this.changeDirection('y');
				}
			};
		}



		/**
		 * Clear canvas.
		 */
		function clearCanvas() {
			ctx.clearRect(0, 0, width, height);
		}



		/**
		 * Create particles.
		 */
		function createParticles() {
			let p;
			for (let i = particleCount - 1; i >= 0; i--) {
				p = new Particle();
				particles.push(p);
			}
		}



		/**
		 * Draw particles.
		 */
		function drawParticles() {
			let p;
			for (let i = particleCount - 1; i >= 0; i--) {
				p = particles[i];
				p.draw();
			}


		}



		/**
		 * Update particles.
		 */
		function updateParticles() {
			let p;
			for (let i = particles.length - 1; i >= 0; i--) {
				p = particles[i];
				p.move();
				p.boundaryCheck();

			}
		}


		/**
		 * Init particle system.
		 */
		function initParticleSystem() {
			createParticles();
			drawParticles();
		}



		/**
		 * Animate particles.
		 */
		function animateParticles() {
			clearCanvas();
			setDelta();
			update();
			drawParticles();
			updateParticles();
			requestAnimationFrame(animateParticles);
		}


		/**
		 * Set delta.
		 */
		function setDelta() {
			const now = (new Date()).getTime();
			mouse.delta = (now - then) / 1000;
			const then = now;
		}



		/**
		 * Update.
		 */
		function update() {
			if (isNaN(mouse.delta) || mouse.delta <= 0) {return;}

			const distX = mouse.x - (mouse.rx);
			const distY = mouse.y - (mouse.ry);

			if (distX !== 0 && distY !== 0) {
				mouse.rx -= ((mouse.rx - mouse.x) / mouse.speed);
				mouse.ry -= ((mouse.ry - mouse.y) / mouse.speed);
			}
		}


		// run
		initParticleSystem();
		requestAnimationFrame(animateParticles);
	});
</script>


// WEBPACK FOOTER //
// src/components/sections/Home.vue